import React, { Component } from 'react';
import {connect} from 'react-redux';
import Calendar from 'react-calendar';
import { parseStringToDate, parseDateToString } from '../../js/utility';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  setBookingPax,
  setBookingDate,
} from '../../actions/booking';

class FordCalendar extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.getUnavailDates = this.getUnavailDates.bind(this);
    this.addFullyBookedClasses = this.addFullyBookedClasses.bind(this);
  }

  getUnavailDates(availDates) {
    const parsedDates = availDates.map((date) => parseStringToDate(date).setHours(0, 0, 0, 0));
    return ({ date }) => {
      return !parsedDates.includes(date.setHours(0, 0, 0, 0));
    };
  }

  addFullyBookedClasses({ date, view }) {
    const { unavailDates } = this.props;
    let parsedDate = parseDateToString(date);
    if(view === 'month' && unavailDates.includes(parsedDate)) {
      return 'fully-booked';
    }
  }

  handleChange(val) {
    const parsedDate = parseDateToString(val);
    const { setBookingDate, handleDateChange, pax, availableSlot } = this.props;

    // Checking if trip is custom date trip
    const slotDates = Object.keys(availableSlot[0]);
    if (slotDates.length){
      if ( availableSlot[0][parsedDate] < pax.pax_max){
        pax.current_pax_max = parseInt(availableSlot[0][parsedDate]);
      }
      else if (pax.current_pax_max !== pax.pax_max) {
        pax.current_pax_max = pax.pax_max;
      }
    }

    setBookingDate(parsedDate);
    // Check if handleDateChange prop was provided, mainly for booking step 1
    //  where we need to re-fectch data based on new date
    if(handleDateChange) {
      handleDateChange(parsedDate);
    }
  }

  render() {
    const { availDates, i18n, customAvailDates } = this.props;

    return(
      <Calendar
        className="fe-calendar"
        showNeighboringMonth={false}
        onClickDay={this.handleChange}
        value={parseStringToDate(this.props.date)}
        activeStartDate={parseStringToDate(availDates[0])}
        minDate={parseStringToDate(availDates[0])}
        maxDate={parseStringToDate(availDates[availDates.length - 1])}
        minDetail="month"
        locale={i18n.language}
        //tileClassName={this.addFullyBookedClasses}
        tileDisabled={customAvailDates ? this.getUnavailDates(customAvailDates) : this.getUnavailDates(availDates)}
        selectRange={false}
      />
    );
  }
}

FordCalendar.propTypes = {
  availDates: PropTypes.array.isRequired,
  unavailDates: PropTypes.array.isRequired,
  date: PropTypes.string.isRequired,
  setBookingDate: PropTypes.func.isRequired,
  setBookingPax: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
  handleDateChange: PropTypes.func,
  customAvailDates: PropTypes.array,
  pax: PropTypes.object,
  bookingPax: PropTypes.oneOfType([PropTypes.number, PropTypes.object])
    .isRequired,
  availableSlot: PropTypes.array
};

const mapStateToProps = ({ bookingState, tripDetailsState }) => ({
  availDates: bookingState.availDates,
  unavailDates: bookingState.unavailDates,
  date: bookingState.date,
  pax: tripDetailsState.currentTrip.pax,
  availableSlot: tripDetailsState.currentTrip.available_slot,
  bookingPax: bookingState.pax
});

const mapDispatchToProps = {
  setBookingDate,
  setBookingPax,
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(FordCalendar));

